import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/blogs/DynamicBlog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/layouts/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/layouts/Navbar.tsx");
